import React      from 'react';
import PropTypes  from 'prop-types';
import classNames from 'classnames';
import { CheckmarkCircleIcon } from '../';

import './loader-button.scss';

class LoaderButton extends React.Component {
    render() {
        const {
            busy,
            disabled,
            done,
            error,
            customClass,
            tabIndex,
            id
        } = this.props;

        const classes = classNames( {
            'btn': true,
            'btn-loader': true,
            'busy': busy,
            'disabled': disabled,
            'done': done,
            'error': error,
            [ customClass ]: customClass
        } );

        const handleClick = event => {
            event.preventDefault();

            if ( !disabled && !busy ) {
                this.props.onClick();
            }
        };

        const doneComponent = <span className="loader-button-icon"><CheckmarkCircleIcon/></span>;
        const busyComponent = (
            <span className="loader-button-icon" ref={ this.beginAnimation } >
                <svg className="spinner" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
                    <g>
                        <circle className="path" fill="none" strokeWidth="2" strokeLinecap="round" cx="12" cy="12" r="10"></circle>
                    </g>
                </svg>
            </span> );

        const content = done ? doneComponent : ( busy ? busyComponent : this.props.children );

        return (
            <button
                id={ id }
                className={ classes }
                onClick={ handleClick }
                disabled={ disabled }
                tabIndex={ tabIndex || null }>
                { content }
            </button>
        );
    }

    beginAnimation = ( element ) => {
        if ( element ) {

            const svg = element.childNodes[ 0 ];
            const group = svg.childNodes[ 0 ];
            const circle = group.childNodes[ 0 ];

            const now = window.performance ? window.performance.now() : new Date().valueOf();
            const duration = 1600.00;
            const offset = 68.00;

            const animate = () => {
                const percent = ( ( ( window.performance ? window.performance.now() : new Date().valueOf() - now ) / duration ) % 1 ) ;

                const groupRoteate = percent * 270;
                group.setAttribute( 'transform', 'rotate(' + groupRoteate.toString() + ', 12, 12)' );

                const strokeDashoffset = ( ( Math.abs( percent - .5 ) / .5 ) * ( offset - ( offset / 4 ) ) ) + ( offset / 4 );
                circle.style.strokeDashoffset = strokeDashoffset;

                const strokeRotate = percent * 360;
                circle.setAttribute( 'transform', 'rotate(' + strokeRotate.toString() + ', 12, 12)' );

                window.requestAnimationFrame( animate );
            };

            if ( typeof window.requestAnimationFrame === 'function' ) {
                animate();
            }
        }
    };
}

LoaderButton.propTypes = {
    busy: PropTypes.bool,
    children: PropTypes.node,
    customClass: PropTypes.string,
    disabled: PropTypes.bool,
    done: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    tabIndex: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] )
};

export default LoaderButton;
